import { AxiosError } from 'axios';
import { addErrorToast, CustomMessage } from './toast/ToastUtils';
import { createIntl, createIntlCache } from 'react-intl';
import { getDefaultCulture } from '../user/language/utilities/languageUtilities';
import translations from '../../i18n/index';

function isAxiosError(error: AxiosError | unknown): error is AxiosError {
  if (!error) return false;

  return (error as AxiosError).isAxiosError === true;
}

const culture = getDefaultCulture();
const intlCache = createIntlCache();
const intl = createIntl({ locale: culture, messages: translations[culture] }, intlCache);

export const handleError = (error: AxiosError | unknown, shouldReturnMessage?: boolean): void | CustomMessage => {
  let customError: CustomMessage = {
    message: intl.formatMessage({ id: 'errors.generic' }),
  };
  if (isAxiosError(error)) {
    // Deal with javascript errors here -> AxiosError
    if (error.response) {
      customError = {
        message: intl.formatMessage({ id: `errors.http.${error.response.status}` }),
      };
    }
  } else {
    // Deal with javascript errors here -> Error
  }

  // In some cases we might want to return the error message instead of showing toast.
  // Add conditions for a mix of the two
  if (shouldReturnMessage) {
    return customError;
  } else {
    addErrorToast(customError);
  }
};
